import { render } from "./UserManagementDetail.vue?vue&type=template&id=6e14e6ff&scoped=true"
import script from "./UserManagementDetail.vue?vue&type=script&lang=js"
export * from "./UserManagementDetail.vue?vue&type=script&lang=js"

import "./UserManagementDetail.vue?vue&type=style&index=0&id=6e14e6ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e14e6ff"]])

export default __exports__